import React, { Component } from "react";
import StepOne from './step_one';
import StepTwo from './step_two';
import StepThree from './step_three';
import StepFour from './step_four';
import StepFive from './step_five';

import { ToastContainer, toast } from 'react-toastify';
import { JobDetailById, postJobSteps } from "../../action/jobs";
import { getsessionStorage, setsessionStorage } from "../../utils";
import constant from "../../constant";
import Loader from "../Common/Loader";
import Swal from "sweetalert2";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

export default withRouter(class PostAJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            JOB_ID: getsessionStorage(constant.keys.jobPostingSession),
            data: undefined,
        };
        this.onSubmitStepOne = this.onSubmitStepOne.bind(this);
        this.onSubmitStepTwo = this.onSubmitStepTwo.bind(this);
        this.onSubmitStepThree = this.onSubmitStepThree.bind(this);
        this.onSubmitStepFive = this.onSubmitStepFive.bind(this);

    }

    componentDidMount() {
        if (this.state.JOB_ID) {
            this.loadJobData();
        }
    }

    loadJobData() {
        JobDetailById(this.state.JOB_ID).then((res) => {
            if (res.status) {
                this.setState({ data: res.result });
            } else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }
        });
    }

    onSubmitStepOne(model) {
        postJobSteps(model, 1).then((res) => {
            if (res.status) {
                if (!this.state.JOB_ID) {
                    setsessionStorage(constant.keys.jobPostingSession, res.result.jobId);
                    this.setState({ JOB_ID: res.result.jobId }, () => {
                        this.props.nextStep();
                        toast.success(res.result.message);
                        this.loadJobData(); // Ensure data is reloaded after setting JOB_ID
                    });
                } else {
                    this.props.nextStep();
                    toast.success(res.result.message);
                }
            } else {
                toast.error(res.error);
            }
        });
    }

    onSubmitStepTwo(model) {
        model.JOB_ID = this.state.JOB_ID;
        postJobSteps(model, 2).then((res) => {
            if (res.status) {
                this.props.nextStep();
                toast.success(res.result.message);
                this.loadJobData(); 
            } else {
                toast.error(res.error);
            }
        });
    }

    onSubmitStepThree(model) {
        model.JOB_ID = this.state.JOB_ID;
        postJobSteps(model, 3).then((res) => {
            if (res.status) {
                this.props.nextStep();
                toast.success(res.result.message);
                this.loadJobData(); 
            } else {
                toast.error(res.error);
            }
        });
    }

    onSubmitStepFive(model) {
        return new Promise((resolve, reject) => {
            postJobSteps(model, 5).then((res) => {
                if (res.status) {
                    Swal.fire({
                        icon: 'success',
                        text: res.result.message,
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(() => {
                        debugger
                        sessionStorage.clear();
                        this.props.history.push(constant.component.JobList.url);
                        resolve();
                    });
                } else {
                    toast.error(res.error);
                    reject(new Error(res.error));
                }
            }).catch((err) => {
                toast.error(`Error: ${err.message}`);
                reject(err);
            });
        });
    }

    render() {
        const { currentStep, showLoader, nextStep, prevStep } = this.props;
        const { JOB_ID, data } = this.state;

        return (
            <React.Fragment>
                <ToastContainer />
                {showLoader && <Loader />}
                {currentStep === 'basic' && (
                    JOB_ID ? (
                        data && (
                            <StepOne
                                onSubmit={this.onSubmitStepOne}
                                Data={data}
                                JOB_ID={JOB_ID}
                            />
                        )
                    ) : (
                        <StepOne
                            onSubmit={this.onSubmitStepOne}
                        />
                    )
                )}

                {currentStep === 'candidate-requirement' && data && (
                    <StepTwo
                        onSubmit={this.onSubmitStepTwo}
                        prevStep={prevStep}
                        Data={data}
                    />
                )}
                {currentStep === 'interview-information' && (
                    <StepThree
                        onSubmit={this.onSubmitStepThree}
                        prevStep={this.props.prevStep}
                        Data={data}
                    />
                )}
                {currentStep === 'job-preview' && (
                    <StepFour
                        nextStep={this.props.nextStep}
                        prevStep={this.props.prevStep}
                        Data={data}
                    />
                )}
                {currentStep === 'submit' && (
                    <StepFive
                        onSubmit={this.onSubmitStepFive}
                        prevStep={this.props.prevStep}
                        Data={data}
                    />
                )}
            </React.Fragment>
        );
    }
}
)